import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import ReactTooltip from 'react-tooltip'
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
  arrayMove,
} from 'react-sortable-hoc'

const DragHandle = SortableHandle(() =>
  <p className='pointer-hand grey-text move-down-five'>
    ☰
  </p>
)

const SortableItem = SortableElement(({id, name, currentUser}) =>
  <div>
    <div className='row'>
      <div className='col-md-1'>
        {currentUser.superadmin ? (
          <DragHandle />
        ) : (
          <p className='light-grey-text move-down-five'>
            ☰
          </p>
        )}
      </div>
      <div className='col-md-9'>
        <p className='move-down-five'>
          {name}
        </p>
      </div>
      <div className='col-md-2'>
        {currentUser.superadmin ? (
          <a className='btn btn-text pull-right'
             data-confirm='Are you sure you want to delete this member type?'
             data-method='delete'
             href={'/member_types/' + id}>
            DELETE
          </a>
        ) : (
          <span data-tip='Only super admins have the ability to delete member types' className="pull-right">
            <a className='btn btn-text disabled'>
              DELETE
            </a>
            <ReactTooltip />
          </span>
        )}

        {currentUser.superadmin ? (
          <a className='btn btn-text pull-right'
             href={'/member_types/' + id + '/edit'}>
            EDIT
          </a>
        ) : (
          <span data-tip='Only super admins have the ability to edit member types' className="pull-right">
            <a className='btn btn-text disabled'>
              EDIT
            </a>
            <ReactTooltip />
          </span>
        )}
      </div>
    </div>
    <hr />
  </div>
)

const SortableList = SortableContainer(({items, currentUser}) => {
  return (
    <span>
      <hr />
      {items.map((item, index) => (
        <SortableItem
          key={`item-${index}`}
          index={index}
          id={item.id}
          name={item.name}
          currentUser={currentUser} />
      ))}
    </span>
  )
})

class MemberTypes extends React.Component {
  state = {
    memberTypes: this.props.memberTypes
  }

  updateMemberType(memberType) {
    axios.put('/member_types/' + memberType.id + '.json',
      {
        member_type: {
          sort_order: memberType.sort_order
        }
      }
    )
    .then(function (response) {
      console.log(response)
    })
    .catch(function (error) {
      toastr.error('Error member type not updated')
      console.log(error)
    })
  }

  saveOrder() {
    var that = this
    var memberTypes = []

    _.forEach(this.state.memberTypes, function(memberType, index) {
      memberType.sort_order = index + 1
      memberTypes.push(memberType)
      that.updateMemberType(memberType)
    })

    this.setState({ memberTypes: memberTypes })
  }

  onSortEnd = ({oldIndex, newIndex}) => {
    this.setState({
      memberTypes: arrayMove(this.state.memberTypes, oldIndex, newIndex)
    }, () => {
      this.saveOrder()
      toastr.info('Order updated')
    })
  }

  render() {
    return(
      <div>
        <div className="row">
          <div className="col-xs-3">
            <h4><b>Member Types</b></h4>
          </div>
          <div className="col-xs-9">
            <div className="pull-right">
              {this.props.currentUser.superadmin ? (
                <a className='btn btn-text'
                  href='/member_types/new'>
                  ADD MEMBER TYPE
                </a>
              ) : (
                <span data-tip='Only super admins have the ability to add member types'>
                  <a className='btn btn-text disabled'>
                    ADD MEMBER TYPE
                  </a>
                  <ReactTooltip />
                </span>
              )}
            </div>
          </div>
        </div>

        <p className='grey-text'>
          Setup your member types for member and household management. To
          change the order member types appear simply drag and drop the rows.
        </p>

        <SortableList
          items={this.state.memberTypes}
          currentUser={this.props.currentUser}
          onSortEnd={this.onSortEnd}
          useDragHandle={true}
        />
      </div>
    )
  }
}

MemberTypes.propTypes = {
  memberTypes: PropTypes.array,
  currentUser: PropTypes.object
}

export default MemberTypes
